import {ModalProps} from "react-bootstrap/Modal";
import {Button, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";

import {Upload} from "react-bootstrap-icons";
import {Trash3} from "react-bootstrap-icons";
import {IMedia} from "../../store/sliceModal";
import {fetchDeleteFile, fetchUploadFile} from "../../fetch/FileRequest";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceModal";
import musicIcon from "../../image/music.png"
import {config} from "../../config";

const ModalMedia:FC<ModalProps & IMedia> = (props) => {
    const {file, isAudio} = props
    const dispatch = useDispatch<AppDispatch>();

    const deleteHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        fetchDeleteFile(file?.id!, false).then(resp => {
            if (resp.status && resp.status < 400) {
                dispatch(actions.closeMediaModal())
            }
        })
    },[file?.id])

    const downloadHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        fetchUploadFile(file?.id!, props.name)
    },[file?.id])

    return (
        <Modal
            {...props}
            size={"lg"}
            fullscreen
            //    centered
        >
            <Modal.Header closeButton style={{gap: "10px"}}>
                <Button variant={"outline-success"} onClick={downloadHandle}>
                    <Upload style={{marginRight: "5px"}}/>
                    Загрузить
                </Button>
                <Button variant={"outline-danger"} onClick={deleteHandle}>
                    <Trash3 style={{marginRight: "5px"}}/>
                    Удалить</Button>
            </Modal.Header>
            {file?.id && <Modal.Body style={{justifyContent: "center", display: "flex"}}>
                {isAudio && <div style={{display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px"}}>
                    <img src={musicIcon} alt={"icon"}/>
                    <audio src={`${config.baseurl}/api/media/${file.id}`} controls/>
                </div>}
                {!isAudio && <video style={{width: "-webkit-fill-available"}} src={`${config.baseurl}/api/media/${file.id}`} controls/>}
            </Modal.Body>}
            <Modal.Footer style={{justifyContent: "center"}}>{`${file?.name}.${file?.type}`}</Modal.Footer>
        </Modal>
    )
        ;
}

export default memo(ModalMedia)
